import { useVariant } from '@calendly/feature-check-react'
import { useOnValueChange } from '@calendly/hooks'
import { useAiEventOccurred } from '@calendly/rich-text-editor'
import { Segment } from '@calendly/segment'
import { useCallback, useState } from 'react'

import { useEventType } from 'features/event_type_provider'
import { useTrack } from 'hooks/analytics_events'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'


const enqueueAIAnalyticsEvent = (track, eventTypeId, status, aiEvent) => {
  const properties = {
    action_name: 'user_updates_long_description',
    action_type: 'et',
    action_status: status,
    action_details: {
      ai_content: aiEvent,
      id: eventTypeId,
    },
    squad_ownership: 'core_ai',
    business_initiative: 'ai_text_test',
    capture_date_begin: 'April 1 2024',
    capture_date_end: 'April 30 2024',
  }

  track({
    name: TRACKING_EVENT_NAMES.USER_ACTION_CAPTURED,
    properties
  })
  Segment.track('User Action Captured', properties)
}

export const useDescriptionAnalytics = () => {
  const track = useTrack()
  const eventType = useEventType()
  const aiFeaturesEnabled = ['enabled_multi_buttons'].includes(useVariant('ai_text_editor'))
  const aiEventOccurred = useAiEventOccurred()

  const [descriptionDidChange, setDescriptionDidChange] = useState(false)

  // quill does a mysterious API source delta that removes some whitespaces
  const normalizedDescription = eventType?.description?.replace(/\s+/g, '')
  useOnValueChange(normalizedDescription, () => {
    if (!descriptionDidChange && aiFeaturesEnabled) {
      enqueueAIAnalyticsEvent(track, eventType.id, 'edit', aiEventOccurred)
      setDescriptionDidChange(true)
    }
  })

  const handleDescriptionChangeOnSave = useCallback(() => {
    if (descriptionDidChange && aiFeaturesEnabled) {
      enqueueAIAnalyticsEvent(track, eventType.id, 'save', aiEventOccurred)
    }
  }, [track, aiEventOccurred, aiFeaturesEnabled, descriptionDidChange, eventType.id])

  return { handleDescriptionChangeOnSave }
}
